import React from 'react';

const InputField = ({
    label,
    name,
    type = "text",
    placeholder,
    icon: Icon,
    required = false,
    error,
    onChange,
    value,
    optionalText = "(Optional)",
    className = ""
}) => {
    return (
        <div className={`w-full p-4 flex flex-col justify-center text-left hover:bg-gray-50 transition-colors rounded-xl ${error ? 'bg-red-50/50' : ''} ${className}`}>
            <label className={`text-[10px] font-bold uppercase tracking-wider mb-1 px-1 ${error ? 'text-red-500' : 'text-gray-400'}`}>
                {label} {required && <span className="text-red-500">*</span>} {!required && <span className="text-gray-300 font-normal normal-case">{optionalText}</span>} {error && <span className="lowercase font-medium ml-2">({error})</span>}
            </label>
            <div className="flex items-center px-1">
                {Icon && <Icon className={`w-4 h-4 mr-3 ${error ? 'text-red-500' : 'text-primary'}`} />}
                <input
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    className="w-full outline-none font-medium text-darkText placeholder-gray-400 bg-transparent text-sm"
                    onChange={onChange}
                    value={value}
                />
            </div>
        </div>
    );
};

export default InputField;
